import { Card, Flex, Form, Input, Row, Col, Button } from 'antd'
import { FormInstance } from 'antd/lib'
import { useState } from 'react'

import { Placeholder } from 'src/api/requests/models/Placeholder'
import { CardWithTitle, requiredRules, SaveConfirm } from 'src/components'
import { useLocales } from 'src/locales'

import { ChannelsSelect, EventsSelect, RolesCheckboxes } from '..'

import { LanguageTabs } from './TabItems'

type Props = {
  form: FormInstance
  isPending?: boolean
  onSubmit: () => void
  onCancel: () => void
}

export const CreateNotificationCard = ({
  form,
  onSubmit,
  onCancel,
  isPending
}: Props) => {
  const { t } = useLocales()

  const [placeholders, setPlaceholders] = useState<Placeholder[]>([])

  return (
    <Card bordered={false}>
      <Form layout="vertical" form={form} requiredMark={false}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item
              name="name"
              label={t('notification_templates.name')}
              rules={requiredRules}
            >
              <Input placeholder={t('notification_templates.name')} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="actionUrl"
              label={t('notification_templates.action_url')}
            >
              <Input placeholder={t('notification_templates.action_url')} />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="eventId"
              label={t('notification_templates.event')}
              rules={requiredRules}
            >
              <EventsSelect setPlaceholders={setPlaceholders} />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="channelId"
              label={t('notification_templates.chanel')}
              rules={requiredRules}
            >
              <ChannelsSelect />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name="destinationRoles" valuePropName="value">
              <RolesCheckboxes />
            </Form.Item>
          </Col>

          <Col span={24}>
            <CardWithTitle title={t('notification_templates.notification')}>
              <LanguageTabs form={form} placeholders={placeholders} />
            </CardWithTitle>
          </Col>

          <Col span={24}>
            <Flex justify="center" gap={16}>
              <Button onClick={onCancel}>{t('common.cancel')}</Button>

              <SaveConfirm
                title={`${t('common.save')}?`}
                onConfirm={onSubmit}
                okButtonProps={{ loading: isPending }}
              >
                <Button type="primary">{t('common.save')}</Button>
              </SaveConfirm>
            </Flex>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}
